<template>
    <div>
        <div class="container">
            <template v-if="page != null">
                <h3>{{ page.title }}</h3>
                <div class="content" style="font-size: initial">
                    <span v-html="page.content"></span>
                </div>
            </template>
            <template v-else>
                <b>Error! </b>
                <h6>
                    Page can not be loaded!
                </h6>
            </template>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                page: {
                    title: '',
                    slug: '',
                    content: ''
                },
                errorMsg: null
            }
        },
        created() {
            this.getData();
        },
        methods: {
            getData() {
                this.axios
                    // .get('page.json')
                    .get('/?action=PageController_ajaxGetPageBySlug&slug=' + this.$route.params.slug)
                    .then(response => {
                        this.page = response.data;
                    })
                    .catch(response => {
                        this.page = null;
                    });
            }
        }
    }
</script>
